import { useState } from "react";
import "./Partner.css";

const partnerLogos = [
  "Acintyo.webp",
  "DA.webp", 
  "Enorvision.webp",
  "Gods.webp",
  "HBF.webp",
  "Indus.webp",
  "Taiiki.webp"
];

export const Partner = () => {
  const [paused, setPaused] = useState(false);

  return (
    <section className="partner-section">
      <div className="partner-container">
        {/* Header */}
         <header className="partner-header">
          <p className="partner-subtitle">
            TRUSTED PARTNERS
          </p>
          <h2 className="partner-title">
            Building Success Together
          </h2>
          <p className="partner-description">
            At AQT Direct, we believe that meaningful growth happens when strong partnerships come together with a shared vision. Our network of trusted partners spans multiple industries, each bringing deep expertise, innovation, and a commitment to excellence. By combining their on-ground knowledge with our strategic private equity insight, we create purposeful collaborations that open new opportunities and accelerate progress. Every partnership is built on trust, transparency, and long-term alignment. We work side-by-side with our partners—not just as investors, but as strategic collaborators—helping them scale smarter, strengthen operations, and unlock sustainable value. Together, we build businesses that stand stronger, compete better, and grow faster in an ever-changing market.
          </p>
        </header>

        {/* Marquee Logos */}
        <div className="marquee-container">
          <div
            className="marquee-content"
            style={{ animationPlayState: paused ? "paused" : "running" }}
          >
            {[...partnerLogos, ...partnerLogos].map((logo, index) => (
              <div
                key={index}
                className="logo-container"
                onMouseEnter={() => setPaused(true)}
                onMouseLeave={() => setPaused(false)}
              >
                <img
                  src={require(`./${logo}`)}
                  alt={`partner logo ${index + 1}`}
                  className="logo-image"
                />
              </div>
            ))}
          </div>
        </div>

        {/* Gradient Overlay */}
        <div className="gradient-overlay" />
      </div>
    </section>
  );
};